// utils
import React from "react";

// custom utils

// translations

/**
 * BtnBgLemon component
 * contains BtnBgLemon component
 * @returns HTML element BtnBgLemon component
 */
export default function BtnBgLemon(props: {url?: string, text: string})  {

    // solves broken layout of some pages in build
    const [hasMounted, setHasMounted] = React.useState(false);
    React.useEffect(() => {
      setHasMounted(true);
    }, []);
    if (!hasMounted) {
      return null;
    }

    return (
        <>
            <a href={props.url} className="button-wo-border bg-divelit-lemon paragraph-small">{props.text}<img className="button-arrow"></img></a>
        </>
    );
}
